import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { sendRequest } from "../../helpers/ajax";
import IEmailRegistrationRequest from "../../types/IEmailRegistrationRequest";
import IEmailRegistrationResponse from "../../types/IEmailRegistrationResponse";
import IResponse from "../../types/IResponse";
import { IToggleUserStatusRequest } from "../../types/IToggleUserStatusRequest";
import { IUser } from "../../types/IUser";
import UserEdit from "./UserEdit";

interface IUserEditContainerState {
    userID: number;
    loading: boolean;
    user: IUser;
}

class UserEditContainer extends React.Component<RouteComponentProps<any>, IUserEditContainerState> {

    constructor(props: RouteComponentProps<any>) {
        super(props);

        this.state = {
            userID: this.props.match.params.userID ? this.props.match.params.userID : 0,
            loading: false,
            user: { email: "", firstName: "", lastName: "", isActive: true, id: -1, userRoles: [] }
        };

        this.loadUser = this.loadUser.bind(this);
        this.saveUser = this.saveUser.bind(this);
        this.sendRegistrationEmail = this.sendRegistrationEmail.bind(this);
        this.toggleUserStatus = this.toggleUserStatus.bind(this);
    }

    public async componentDidMount() {
        this.loadUser();
    }

    public render() {
        return (
            <UserEdit loading={this.state.loading}
                user={this.state.user}
                saveUser={this.saveUser}
                sendRegistrationEmail={this.sendRegistrationEmail}
                toggleUserStatus={this.toggleUserStatus} />
        );
    }

    private async saveUser(user: IUser): Promise<IResponse<IUser> | null> {

        this.setState({ loading: true });

        const response = await sendRequest<IResponse<IUser>>("/api/user/save", "POST", user);

        this.setState({ loading: false });

        if (response && response.success && response.payload) {

            this.setState({ userID: response.payload.id, user: response.payload });
        }

        return response;
    }

    private async loadUser() {
        this.setState({ loading: true });
        const response = await sendRequest<IResponse<IUser>>(`/api/user/getbyid/${this.state.userID}`, "GET");

        this.setState({ loading: false });

        if (response && response.success) {
            this.setState({ user: response.payload });
        }
    }

    private async sendRegistrationEmail() {
        this.setState({ loading: true });

        const request: IEmailRegistrationRequest = { email: this.state.user.email };
        await sendRequest<IResponse<IEmailRegistrationResponse>>("/api/register/emailregistration", "POST", request);

        this.setState({ loading: false });
    }

    private async toggleUserStatus(status: boolean) {
        this.setState({ loading: true });

        const request: IToggleUserStatusRequest = { userID: this.state.userID, isActive: status };
        const response = await sendRequest<IResponse<IUser>>("/api/user/toggleuserstatus", "POST", request);

        this.setState({ loading: false });

        if (response && response.success) {
            this.setState({ user: response.payload });
        }
    }
}

export default withRouter(UserEditContainer);



// WEBPACK FOOTER //
// ./src/components/UserEdit/UserEditContainer.tsx